import ForgotPassword from '../components/login/ForgotPassword';
const ForgotPasswordPage: React.FC = () => <ForgotPassword />;
export default ForgotPasswordPage;
